import styled from 'styled-components';
import MuiSkeleton from '@mui/material/Skeleton';

export const StyledSkeleton = styled(MuiSkeleton)`
  width: 100%;
  max-width: 100%;
`;

export const ParagraphSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s2};
`;
